PageApp.Controllers.AdminLoginRouter = function () {
  function initEvents () {
    myApp.vent.on('admin:login:display', function (models) {
      myApp.footerRegion.show(new PageApp.Views.AdminFooterView())
      myApp.headerRegion.show(new PageApp.Views.AdminHeaderView())
      if (models.coreModel.amnesia) {
        myApp.mainRegion.show(new PageApp.Views.LoginAmnesiaView({ model: new PageApp.Ent.BasicEntity({ users: models.allowedWebApps }) }))
      } else {
        myApp.mainRegion.show(new PageApp.Views.LoginView({ model: new PageApp.Ent.Login(models.loginModel), errors: models.errorsModel, admin: true }))
      }
    }, this)
  }
  return {
    initialize: function () {
      initEvents()
    }
  }
}
